import { render } from "./aboutIndex.vue?vue&type=template&id=3e6cbd3e"
import script from "./aboutIndex.vue?vue&type=script&lang=js"
export * from "./aboutIndex.vue?vue&type=script&lang=js"

import "./aboutIndex.vue?vue&type=style&index=0&id=3e6cbd3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__